import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";
export const Takeout = () => {
    return (
        <>
            <PageHeader />
            <DataBox />
        </>
    )
}